import Swal from 'sweetalert2';
import { HttpClient, HttpEvent, HttpEventType, HttpRequest } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UploadService } from 'src/app/_core/services/upload.service';
import { MovimentacaoService } from 'src/app/_core/services/movimentacao.service';
import { Arquivo } from 'src/app/_core/models/arquivo';
import { environment as env } from 'src/environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Evidencia } from 'src/app/_core/models/evidencia';
@Component({
  selector: 'app-tela-inconsistencias-gestor-modal',
  templateUrl: './tela-inconsistencias-gestor-modal.component.html',
  styleUrls: ['./tela-inconsistencias-gestor-modal.component.scss']
})
export class TelaInconsistenciasGestorModalComponent implements OnInit {
  @Input() public nR_BPM_BEM_PATRIMONIAL: number;
  @ViewChild('file') file:any;
  public progress: number;
  message:string;
  loading = true;
  arquivo:Arquivo;
  arquivos:Arquivo[] = [];
  arquivoEv:Arquivo;
  form !: FormGroup;
  evidencia:Evidencia;
  constructor( 
    private fb: FormBuilder,
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private uploadService: UploadService,
    private movimentacaoService: MovimentacaoService,
    private http: HttpClient,) { }

  ngOnInit(): void {
    this.evidencia = new Evidencia();
    this.arquivoEv =  JSON.parse(localStorage.getItem('arquivos') || '{}');
    this.loading = false;
    this.gerarForm(this.evidencia);
  }
  gerarForm(evidencia:Evidencia){
    this.form = this.fb.group({
      // cD_BPM_NR_UNIDADE:[localizacao.cD_BPM_NR_UNIDADE,[Validators.required]],
      dS_BPM_TEXTO_EVIDENCIA:[evidencia.dS_BPM_TEXTO_EVIDENCIA,[]],
      cD_BPM_ARQUIVO_PATRIMONIAL:[evidencia.cD_BPM_ARQUIVO_PATRIMONIAL,[Validators.required]],
      fL_BPM_ATIVO:[evidencia.fL_BPM_ATIVO,[]],
      fL_BPM_DELETADO:[0,[]]
    })
  }
  onChange(files:any){
    //console.log/files)
    if (files.length === 0)
    return;
    
    const formData = new FormData();
    
    formData.append('file', files[0]);
    
    const uploadReq = new HttpRequest('POST', env.baseurl + '/Arquivo/Evidencia/'
    + this.nR_BPM_BEM_PATRIMONIAL,
    formData, {
      reportProgress: true
    });

    this.http.request(uploadReq).subscribe((event: any) => {
      if (event.type === HttpEventType.UploadProgress) {
        this.progress = Math.round(100 * event.loaded / event.total);
      } else if (event.type === HttpEventType.Response) {
        this.message = event.body.message;
        Swal.fire(
          'Sucesso!',
          this.message,
          'success'
        ).then(() => {
        });
        this.arquivo = event.body
  
        localStorage.setItem('arquivos', JSON.stringify(this.arquivo));
        this.arquivo = new Arquivo();
      };
    });

  }
   confirmar() {
    this.arquivoEv =  JSON.parse(localStorage.getItem('arquivos') || '{}');
    if ( this.arquivoEv === null){
      this.form.controls['cD_BPM_ARQUIVO_PATRIMONIAL'].setValue(0)
    }
    this.form.controls['cD_BPM_ARQUIVO_PATRIMONIAL'].setValue(this.arquivoEv.cD_BPM_ARQUIVO_PATRIMONIAL)
    const ev:Evidencia = this.form.value;
    if ( ev.cD_BPM_ARQUIVO_PATRIMONIAL === NaN){
      ev.cD_BPM_ARQUIVO_PATRIMONIAL = 0;
    }
    ev.fL_BPM_ATIVO = Number(this.form.controls['fL_BPM_ATIVO'].value);
    //console.log/ev)
    Swal.fire({
      title: 'Deseja confirmar essa inconsistência?',
      confirmButtonText: 'Confirmar',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      icon: 'info',
    }).then((result)=>{
      if(result.value){
        this.movimentacaoService.mov_confirmInGestor(this.nR_BPM_BEM_PATRIMONIAL,ev).
        subscribe(
          data => {
            const msg:string = 'Confirmado com sucesso!'
            Swal.fire(
              'Sucesso!',
              msg,
              'success'
            ).then(() => {
              this.loading = false;
              this.activeModal.close();
            });
          },
          err => {
            ////console.log/JSON.stringify(err))
            let msg:string = 'Erro ao confirmar,tente novamente mais tarde!'
            if(err.status == 401){
              return msg = err.error;
            }
            Swal.fire('Erro',msg,'error').then(()=>{
              this.loading = false;
            });
            ////console.log/JSON.stringify(err))
          }
        )
      }
    })
  }
  cancelar() { 
    this.arquivoEv =  JSON.parse(localStorage.getItem('arquivos') || '{}');
    if ( this.arquivoEv === null){
      this.form.controls['cD_BPM_ARQUIVO_PATRIMONIAL'].setValue(0)
    }
    this.form.controls['cD_BPM_ARQUIVO_PATRIMONIAL'].setValue(this.arquivoEv.cD_BPM_ARQUIVO_PATRIMONIAL)
    const ev:Evidencia = this.form.value;
    if ( ev.cD_BPM_ARQUIVO_PATRIMONIAL === NaN){
      ev.cD_BPM_ARQUIVO_PATRIMONIAL = 0;
    }
    ev.fL_BPM_ATIVO = Number(this.form.controls['fL_BPM_ATIVO'].value);
    //console.log/ev)
    Swal.fire({
      title: 'Deseja cancelar essa inconsistência?',
      confirmButtonText: 'Sim',
      showCancelButton: true,
      cancelButtonText: 'Não',
      icon: 'info',
    }).then((result)=>{
      if(result.value){
        this.movimentacaoService.mov_cancelIncon(this.nR_BPM_BEM_PATRIMONIAL,ev).
        subscribe(
          data => {
            const msg:string = 'Cancelado com sucesso!'
            Swal.fire(
              'Cancelado!',
              msg,
              'success'
            ).then(() => {
              this.loading = false;
              this.activeModal.close();
            });
          },
          err => {
            ////console.log/JSON.stringify(err))
            let msg:string = 'Erro ao cancelar,tente novamente mais tarde!'
            if(err.status == 401){
              return msg = err.error;
            }
            Swal.fire('Erro',msg,'error').then(()=>{
              this.loading = false;
            });
            ////console.log/JSON.stringify(err))
          }
        )
      }
    })
  }
}
